module.exports = __webpack_public_path__ + "fonts/CrimsonText-Italic.fb246cd0.eot";